import { useEffect, useState } from "react";
import "../App.scss";
import "./Header.scss";
import useStore from "../store/store";
import { Link, useNavigate } from "react-router-dom";
const Header = () => {
  const { patients, fetchPatients } = useStore();
  const navigate = useNavigate();
  useEffect(() => {
    const token = localStorage.getItem("token");
    const role = localStorage.getItem("role");
    if (token && role === "Clinician" && patients.length === 0) {
      fetchPatients(); // Only fetch if not already fetched
    }
  }, []);
  const [filteredPatients, setFilteredPatients] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");

  console.log("Patients ", patients);
  const handleChange = (e) => {
    let searchText = e.target.value.toLowerCase();
    console.log("Search query ", searchText);
    setSearchQuery(e.target.value);
    const results = patients.filter(
      (patient) =>
        patient.uid?.toLowerCase().includes(searchText) ||
        patient.firstName?.toLowerCase().includes(searchText) ||
        patient.lastName?.toLowerCase().includes(searchText)
    );
    console.log("Result is ", results);

    setFilteredPatients(results);
  };
  useEffect(() => {
    console.log("filteredPatients ", filteredPatients);
  }, [filteredPatients]);
  const goToPatient = (uid) => {
    //navigate(`/patients/${uid}`);
    setSearchQuery("");
    setFilteredPatients([]);
  };
  return (
    <div className="header-container">
      <div
        className="row"
        style={{
          padding: " 2rem 2.5rem 1rem 2.5rem",
          boxSizing: "border-box",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div className="header">Dashboard</div>
        <div className="search-container">
          <input
            className="search-bar b1"
            type="text"
            name="search"
            id="search"
            placeholder="Search here..."
            onChange={handleChange}
            value={searchQuery}
          />
          {filteredPatients.length > 0 && (
            <div className="dropdownContainer">
              {filteredPatients.map((patient) => (
                <Link
                  className="dropDownLink midGray"
                  to={`/patients/${patient.uid}`}
                  key={patient.uid}
                  onClick={() => goToPatient(patient.uid)}
                >
                  <div className="dropdownContent">
                    {" "}
                    {patient.firstName} {patient.lastName} — {patient.uid}
                  </div>
                </Link>
                // <button
                //   className="dropDownLink midGray iconButton"
                //   key={patient.uid}
                //   onClick={() => goToPatient(patient.uid)}
                // >
                //   <div className="dropdownContent">
                //     {" "}
                //     {patient.firstName} {patient.lastName} — {patient.uid}
                //   </div>
                // </button>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Header;
